import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyFolderDark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 140,
	viewBox: "0 0 412 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 82.1002,
			y1: 57.6055,
			x2: 17.1002,
			y2: 72.6055,
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 95.2109,
			y1: 60.7697,
			x2: 149.162,
			y2: 89.4007,
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 82.1677C13.4183 82.1677 17 78.586 17 74.1677C17 69.7494 13.4183 66.1677 8.99999 66.1677C4.58171 66.1677 1 69.7494 1 74.1677C1 78.586 4.58171 82.1677 8.99999 82.1677Z",
			stroke: "#686869",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M9.00048 77.167C10.6573 77.167 12.0005 75.8238 12.0005 74.167C12.0005 72.5101 10.6573 71.167 9.00048 71.167C7.34362 71.167 6.00049 72.5101 6.00049 74.167C6.00049 75.8238 7.34362 77.167 9.00048 77.167Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.999 63.1682C94.4173 63.1682 97.999 59.5865 97.999 55.1682C97.999 50.7499 94.4173 47.1682 89.999 47.1682C85.5807 47.1682 81.999 50.7499 81.999 55.1682C81.999 59.5865 85.5807 63.1682 89.999 63.1682Z",
			stroke: "#686869",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M89.9995 58.1687C91.6564 58.1687 92.9995 56.8256 92.9995 55.1687C92.9995 53.5119 91.6564 52.1687 89.9995 52.1687C88.3427 52.1687 86.9995 53.5119 86.9995 55.1687C86.9995 56.8256 88.3427 58.1687 89.9995 58.1687Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3229,
			y2: -.45,
			transform: "matrix(-0.920735 -0.390189 -0.390189 0.920735 284.432 117.407)",
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(0.991998 0.126254 0.126254 -0.991998 340.002 51.4072)",
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(0.484316 -0.874893 -0.874893 -0.484316 297.002 114.407)",
			stroke: "#686869",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332.001 43.4077C336.419 43.4077 340.001 46.9894 340.001 51.4077C340.001 55.826 336.419 59.4077 332.001 59.4077C327.583 59.4077 324.001 55.826 324.001 51.4077C324.001 46.9894 327.583 43.4077 332.001 43.4077Z",
			stroke: "#686869",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332.002 48.4072C333.659 48.4072 335.002 49.7504 335.002 51.4072C335.002 53.0641 333.659 54.4072 332.002 54.4072C330.345 54.4072 329.002 53.0641 329.002 51.4072C329.002 49.7504 330.345 48.4072 332.002 48.4072Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403.001 51.407C407.42 51.407 411.001 54.9887 411.001 59.407C411.001 63.8253 407.42 67.407 403.001 67.407C398.583 67.407 395.001 63.8253 395.001 59.407C395.001 54.9887 398.583 51.407 403.001 51.407Z",
			stroke: "#686869",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403.002 56.4065C404.659 56.4065 406.002 57.7496 406.002 59.4065C406.002 61.0633 404.659 62.4065 403.002 62.4065C401.345 62.4065 400.002 61.0633 400.002 59.4065C400.002 57.7496 401.345 56.4065 403.002 56.4065Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292.001 112.407C296.42 112.407 300.001 115.989 300.001 120.407C300.001 124.826 296.42 128.407 292.001 128.407C287.583 128.407 284.001 124.826 284.001 120.407C284.001 115.989 287.583 112.407 292.001 112.407Z",
			stroke: "#686869",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292.002 117.407C293.659 117.407 295.002 118.75 295.002 120.407C295.002 122.064 293.659 123.407 292.002 123.407C290.345 123.407 289.002 122.064 289.002 120.407C289.002 118.75 290.345 117.407 292.002 117.407Z",
			fill: "#C28D10"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M72.245 103.479C72.245 105.499 70.615 107.129 68.595 107.129C66.575 107.129 64.9451 105.499 64.9451 103.479C64.9451 101.459 66.575 99.8289 68.595 99.8289C70.615 99.8289 72.245 101.459 72.245 103.479Z",
			fill: "#EBA23E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M393.046 118.411C388.805 124.867 382.277 133.315 373.371 130.206C364.623 127.145 367.859 116.534 370.96 110.505C373.246 106.04 376.063 101.832 379.363 98.0501C381.503 95.5918 385.069 92.2299 388.666 93.702C391.748 94.9709 392.127 98.8174 391.119 101.596C389.648 105.611 386.429 109.962 383.294 112.805C380.452 115.387 376.353 117.124 372.494 115.968C368.977 114.9 366.849 111.555 366.213 108.076C365.423 103.75 366.538 98.1992 368.406 94.2429C369.549 91.8394 372.177 89.8466 374.648 91.8994C377.584 94.3253 376.2 98.265 374.37 100.858C371.886 104.355 368.714 108.473 364.418 109.749C361.155 110.722 357.395 109.923 355.598 106.829C353.831 103.791 354.411 99.8842 355.147 96.6344C355.761 93.9497 356.991 89.5944 360.478 89.6686C364.003 89.7483 364.947 94.2362 363.516 96.787C361.308 100.731 355.758 102.594 351.576 103.266C346.628 104.065 341.584 103.291 337.076 101.126C336.509 100.851 336.897 99.9455 337.477 100.222C343.334 103.031 350.191 103.377 356.255 100.957C359.164 99.8041 363.848 97.3686 363.2 93.5332C362.857 91.4921 360.756 89.7606 358.752 91.2249C357.343 92.258 356.742 94.2601 356.325 95.8714C355.725 98.2034 355.234 100.742 355.498 103.151C355.93 107.322 359.268 109.859 363.457 108.96C366.875 108.225 369.353 105.538 371.475 102.938C373.489 100.474 377.676 95.5813 374.016 92.6549C369.926 89.3856 368.195 97.7987 367.675 100.105C366.906 103.489 366.493 107.129 367.932 110.41C369.457 113.881 372.695 115.807 376.476 115.19C380.281 114.576 383.149 111.909 385.413 108.95C387.176 106.638 389.237 103.94 390.205 101.181C390.886 99.2413 390.951 96.6652 389.231 95.1928C387.173 93.4296 384.44 94.7604 382.645 96.1797C377.619 100.149 373.845 106.699 371.125 112.38C368.295 118.297 366.373 128.419 375.514 129.688C383.426 130.786 388.493 123.553 392.278 117.777C392.623 117.245 393.406 117.868 393.048 118.398L393.046 118.411Z",
			fill: "#474748"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M168.103 34.1812C169.403 29.5865 173.367 26.0927 178.286 25.5299L198.681 23.1967C199.998 18.6546 203.961 15.0617 209.082 14.5759L236.528 11.9725C241.154 11.5338 245.494 13.7948 247.847 17.5716L264.155 15.7058C271.523 14.8629 277.885 20.8387 277.503 28.2452L274.02 95.8838C273.951 97.2302 273.66 98.5197 273.183 99.7154C272.696 102.629 271.878 104.882 270.223 106.484C268.012 108.625 266.617 109.779 258.813 110.63C258.654 110.652 258.495 110.67 258.334 110.685L257.727 110.743C257.59 110.756 257.45 110.77 257.309 110.783C257.293 110.785 257.278 110.786 257.264 110.787L170.906 118.978C165.132 119.526 159.794 115.866 158.222 110.284L141.505 50.9147C139.476 43.7079 144.469 36.4229 151.923 35.7159L168.103 34.1812Z",
			fill: "#2B2B2C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M276.448 29.4482C277.669 22.1331 272.028 15.4729 264.612 15.4729H178.183C172.295 15.4729 167.277 19.745 166.337 25.5577L155.537 92.3621C154.357 99.659 159.991 106.277 167.383 106.277H253.463C259.328 106.277 264.334 102.038 265.3 96.2526L276.448 29.4482Z",
			fill: "#9E730D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M260.716 90.5985L250.767 34.1302L248.301 19.3693C247.335 13.585 242.33 9.34644 236.465 9.34644H208.896C202.064 9.34644 196.748 14.9954 196.896 21.5896H150.322C142.835 21.5896 137.176 28.3704 138.515 35.7367L149.551 96.4194C150.589 102.125 155.558 106.272 161.358 106.272H248.034C248.069 106.276 248.107 106.277 248.147 106.277C248.523 106.277 248.887 106.276 249.238 106.272C249.284 106.272 249.331 106.271 249.377 106.271C257.473 106.18 258.978 105.162 261.41 103.216C264.55 100.704 265.338 95.976 266.461 89.2323L266.511 88.9326C266.001 91.9935 264.981 93.5239 263.961 93.5239C262.451 93.5239 261.514 92.6864 260.716 90.5985Z",
			fill: "#F3B82C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M179.921 72.5294L176.217 72.7943L175.994 72.8126C175.309 72.8493 175.08 73.1314 174.899 73.4725L172.31 78.1528L169.209 73.9698L169.106 73.8328C169.106 73.8328 169.021 73.7101 168.887 73.7149L168.886 73.7149C168.753 73.7293 168.686 73.8629 168.686 73.8629L168.604 74.0132L166.225 78.588L162.901 74.3306C162.672 74.0188 162.406 73.7722 161.723 73.8332L161.5 73.8468L157.795 74.1117L158.058 77.7634L160.239 77.6074C160.699 77.57 160.913 77.577 161.256 77.9471L161.401 78.1363L166.32 84.9717C166.32 84.9717 166.48 85.1923 166.723 85.1764C166.985 85.1585 167.114 84.9143 167.114 84.9143L169.394 80.7411L169.394 80.7411L172.348 84.5346C172.348 84.5346 172.515 84.7601 172.742 84.7498C172.986 84.7387 173.102 84.486 173.102 84.486L176.93 77.0257L177.046 76.8179C177.245 76.4358 177.527 76.3772 177.985 76.3489L180.169 76.1913L179.921 72.5294Z",
			fill: "#D99E12"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.068 83.0793L172.975 87.1535L169.586 82.7721L167.496 86.6117L173.042 94.3302C173.229 94.541 173.369 94.5782 173.438 94.5756C173.589 94.5717 173.67 94.4821 173.811 94.1881L177.177 86.5373C177.477 85.8722 178.057 85.8391 178.057 85.8391L180.867 85.6381L180.604 81.9913L176.217 82.3051C175.418 82.3622 175.068 83.0793 175.068 83.0793Z",
			fill: "#D99E12"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 45.1534,
			cy: 28.6304,
			r: 13.1651,
			transform: "rotate(-10.3463 45.1534 28.6304)",
			fill: "#BFBFBF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.2062 29.5277L44.6949 32.3098L49.314 25.1637",
			stroke: "#19191A",
			strokeWidth: .9,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.743 112.367C148.086 112.304 142.58 103.451 141.428 92.3057",
			stroke: "#BFBFBF",
			strokeWidth: .763748,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 283.41,
			y1: 32.5717,
			x2: 278.544,
			y2: 56.8992,
			stroke: "#BFBFBF",
			strokeWidth: .763748,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgEmptyFolderDark);
export default ForwardRef;
